export enum Platform {
    WEB = "web",
    MWEB = "mweb",
}

interface initServerHostType {
    serverHost?: string;
    apiDomain: string;
}

export interface CommonRuntime {
    // request 基础信息
    hostname: string;
    pathname: string;
    userAgent: string;
    cookie: string;
    cookies: { [key: string]: string };
    // tights page 基础信息
    version: string;
    id: string;
    // 网站 基础信息
    platform: Platform;
    isUat: boolean;
    countryCode3: string;
    languageCode: string;
    currency: string;
    isInApp: boolean;
    userType?: number; // 用户类型：1 新用户，0 未下单老用户，2 已下单老用户
    // 额外
    countryCode2?: string;
    appKey: string;
    appSecret: string;
    sid: string;
    sessionKey: string;
    multiLanImgKey?: string;
    priceGraph?: string;
    countryId?: string;
    initServerHost: initServerHostType; // server 端 IP / apiDomain 存储
    client?: string;
    __cust: string;
}

let Runtime: Partial<CommonRuntime> = {};

export function setRuntime(runtime: CommonRuntime) {
    Runtime = runtime;
}

export function getRuntime(): Partial<CommonRuntime> {
    return Runtime;
}

export function getMeta(runtime: CommonRuntime) {
    const { countryCode3, languageCode, platform, currency, id } = runtime;
    return {
        catalog: countryCode3,
        lang: languageCode,
        client: platform,
        priceSymbol: currency,
        pageId: id,
    };
}
